import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import {sortables, sort_modes} from 'variables/sortables.jsx'
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: '16px 24px 16px 24px',
    fontFamily: 'Roboto',
  },
  header: {
    flex: '0 0 auto',
    marginBottom: '16px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    display: 'inline-block',
    marginLeft: '7px',
    marginTop: '0px',
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 500,
  },
  selectRoot: {
    display: 'flex',
    marginTop: '16px',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    height: '80%',
    justifyContent: 'space-between',
  },
  selectFormControl: {
    flex: '1 1 calc(50% - 24px)',
    marginRight: '24px',
    marginBottom: '24px',
  },
});


class SortOptionForm extends React.Component {
	constructor (props) {
		super(props);
	}

	handleDropdownChange = (event, index) => {
		//console.log(event, index);
		this.props.updateSort(event.target.value, index);
  	};

	render () {
		const { classes } = this.props;
		return (
			<div className={classes.root}>
			<div className={classes.header}>
				<Typography
              		variant="body2"
              		className={classes.title}>
              		SORT OPTIONS
              	</Typography>
			</div>
			<div className={classes.selectRoot}>
			{
				sortables.map((sortable, index) => (
					<FormControl className={classes.selectFormControl} key={index}>
					<InputLabel>{sortable.name}</InputLabel>
			            <Select
			           		value={this.props.sortOptions[index]}
			              	name={sortable.name}
			              	onChange={event => this.handleDropdownChange(event, index)}
			            >
			            <MenuItem value={sort_modes.NONE} key={0}>
		                	{"None"}
		                </MenuItem>
		                <MenuItem value={sort_modes.ASC} key={1}>
		                	{"Ascending"}
		                </MenuItem>
		                <MenuItem value={sort_modes.DESC} key={2}>
		                	{"Descending"}
		                </MenuItem>
		                </Select>
		            </FormControl>

				))
			}
			</div>
			</div>
		)
	}
}


export default withStyles(styles)(SortOptionForm);